// extracted by mini-css-extract-plugin
module.exports = {"title_large":"TextStyle-module__title_large___S3Jf7","title_medium":"TextStyle-module__title_medium___101PI","title_small":"TextStyle-module__title_small___1fngY"};